import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import QueryString from 'query-string';

import {
  syncSubscriptionByChargifyId,
  redirectFromChargify,
  doUpdateSubscription,
  doReactivateSubscription,
  CHOOSEN_PLAN_KEY,
  LICENCES_COUNT_KEY,
  doRemoveLocalChoosenPlanInfo,
} from '../actions/subscriptions';
import { Loader } from '../components/Loading';
import GenericNotFound from '../components/GenericNotFound';
import DashboardLayout from '../components/DashboardLayout';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { clearMessages } from '../actions/messages';

/** 
 * Page receiving infos from chargify after a user went to update or set
 * his payment info.
 * Takes a subscription_id, synchronizes it, and redirects to the page
 * set before sending the user to Chargify
*/
class ChargifyRedirect extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  // FIXME load data is very convoluted...
  componentWillMount() {
    const {
      loadData,
      redirect,
      reactivate,
      updateSubscription,
      removeLocalStoragePlanInfo,
      history,
      chargifyId
    } = this.props;
    
    loadData(history, chargifyId)
      .then(({error,subscription}) => {
        if( !!(localStorage.getItem(CHOOSEN_PLAN_KEY) && localStorage.getItem(LICENCES_COUNT_KEY))) {
          const planId = localStorage.getItem(CHOOSEN_PLAN_KEY);
          const licencesCount = localStorage.getItem(LICENCES_COUNT_KEY);
          removeLocalStoragePlanInfo(planId, licencesCount);
          return updateSubscription(subscription.id, planId, licencesCount);
        } 
        return {error, subscription};
      })
      .then(({ error, subscription}) => {
        if (subscription.status === 'canceled' || subscription.status === 'trial_ended') {	
          return reactivate(subscription.id);	
        }
        return {error, subscription};
      })
      .then(({ error, subscription }) => {
        if (subscription) {
          return redirect(subscription, history);
        } else {
          this.setState({ error });
        }
      })
  }

  render() {
    const { error } = this.state;
    const { intl } = this.props;
    return (
      <DashboardLayout>
        {
          error
            ? <GenericNotFound
              title={
                intl.messages['subscription.payment.proceeding.error']
              }
            />
            : <div>
              <Typography
                variant="h5"
              >
                <FormattedMessage id='subscription.payment.proceeding' />
              </Typography>
              <Loader />
            </div>
        }
      </DashboardLayout>
    );
  }
}

ChargifyRedirect.propTypes = {
  chargifyId: PropTypes.string.isRequired,
  intl: intlShape.isRequired
}

const mapStateToProps = (state, { location }) => {
  const {
    //customer_reference,
    //product_handle,
    subscription_id
  } = QueryString.parse(location.search);

  return {
    chargifyId: subscription_id || ""
  };
}


const mapDispatchToProps = (dispatch, getState) => {
  return {
    loadData: (history, chargifyId) =>
      dispatch(syncSubscriptionByChargifyId(chargifyId)),
    redirect: (subscription, history) =>
      dispatch(redirectFromChargify(subscription, history)),
    reactivate: (subscriptionId) => {
      dispatch(clearMessages());
      return dispatch(doReactivateSubscription(subscriptionId));
    },
    updateSubscription: (subscriptionId, planId, licencesCount) => {
      dispatch(clearMessages());
      return dispatch(doUpdateSubscription(subscriptionId, planId, licencesCount));
    },
    removeLocalStoragePlanInfo: () => 
      dispatch(doRemoveLocalChoosenPlanInfo()),
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    injectIntl(ChargifyRedirect)
  )
);


// WEBPACK FOOTER //
// ./src/containers/ChargifyRedirect.js